import images from "app/shared/styles/images";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Image, StyleSheet, useWindowDimensions, View } from "react-native";
import { Button, Text } from "react-native-paper";
import Animated, { interpolate, interpolateColor, useAnimatedStyle } from "react-native-reanimated";
import Carousel from "react-native-reanimated-carousel";
import { CarouselRenderItemInfo, ICarouselInstance } from "react-native-reanimated-carousel/lib/typescript/types";
import { Block } from "../blocks/block";
import { QueueSpacing } from "../spacing";

interface TourGuildProps {
  onHideTourGuild: () => void;
}

const data = [
  {
    key: 1,
    source: images.start_guild_1,
  },
  {
    key: 2,
    source: images.start_guild_2,
  },
  {
    key: 3,
    source: images.start_guild_3,
  },
  {
    key: 4,
    source: images.start_guild_4,
  },
];

const TourGuild = (props: TourGuildProps) => {
  const { onHideTourGuild } = props;
  const hideModal = () => {
    onHideTourGuild();
  };
  const { t } = useTranslation();
  const [index, setIndex] = React.useState(0);
  const r = React.useRef<ICarouselInstance>(null);
  const { width } = useWindowDimensions();

  const [widthImage] = React.useState(width * 0.8 < 600 ? width * 0.8 : 600);

  const baseOptions = {
    width: widthImage,
    height: (widthImage * 3) / 4,
    loop: false,
  };
  const animationStyle = React.useCallback(
    (value: number) => {
      "worklet";

      const zIndex = interpolate(value, [-1, 0, 1], [10, 20, 30]);
      const translateX = interpolate(value, [-2, 0, 1], [-baseOptions.width, 0, baseOptions.width]);

      return {
        transform: [{ translateX }],
        zIndex,
      };
    },
    [baseOptions.width],
  );

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        container: { flex: 1, borderRadius: 24 },
        itemContainer: { flex: 1 },
        image: { width: "100%", height: undefined, aspectRatio: 800 / 600 },
        animated: { position: "absolute", top: 0, left: 0, right: 0, bottom: 0 },
        carousel: { borderRadius: 24 },
      }),
    [],
  );

  const renderItem = ({ animationValue, index, item }: CarouselRenderItemInfo<any>) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const maskStyle = useAnimatedStyle(() => {
      const backgroundColor = interpolateColor(animationValue.value, [-1, 0, 1], ["#000000dd", "transparent", "#000000dd"]);

      return {
        backgroundColor,
      };
    }, [animationValue]);

    return (
      <View key={index} style={styles.itemContainer}>
        <Image source={item.source} style={styles.image} />
        <Animated.View pointerEvents="none" style={[styles.animated, maskStyle]} />
      </View>
    );
  };

  return (
    <>
      <Text onPress={hideModal} style={{ color: "white", fontSize: 28, fontWeight: "600" }} children={"X"} />
      <View style={styles.container}>
        <Carousel
          {...baseOptions}
          ref={r}
          style={styles.carousel}
          onSnapToItem={(_index) => {
            setIndex(_index);
          }}
          scrollAnimationDuration={300}
          data={data}
          customAnimation={animationStyle}
          renderItem={renderItem}
        />

        <Block display={index === 0 ? "flex" : "none"} middle row>
          <Button
            mode="contained"
            style={{ marginTop: 16, alignSelf: "center" }}
            onPress={() => r.current?.next()}
            uppercase={false}
            children={t("COMMON_TIEP_TUC")}
          />
        </Block>
        <Block display={index === 0 || index === data.length - 1 ? "none" : "flex"} middle row>
          <Button
            onPress={() => r.current?.prev()}
            mode="contained"
            style={{ marginTop: 16, alignSelf: "center" }}
            // onPress={hideModal}
            uppercase={false}
            children={t("COMMON_QUAY_LAI")}
          />
          <QueueSpacing size="medium" />
          <Button
            mode="contained"
            onPress={() => r.current?.next()}
            style={{ marginTop: 16, alignSelf: "center" }}
            uppercase={false}
            children={t("COMMON_TIEP_TUC")}
          />
        </Block>
        <Block display={index === data.length - 1 ? "flex" : "none"} middle row>
          <Button
            style={{ marginTop: 16, alignSelf: "center" }}
            mode="contained"
            onPress={hideModal}
            uppercase={false}
            children={t("COMMON_KHAM_PHA_NGAY")}
          />
        </Block>
      </View>
    </>
  );
};

export default TourGuild;
